import axiosInstance from "../../api/axiosInstance";
const BASE_URL = process.env.REACT_APP_BASE_URL;

/* ===============================
 TIMETABLE (PUBLIC)
================================ */
export const fetchTimeTable = () => {
 // This is public, axios is fine
 return axiosInstance.get(`/timetable`);
};

/* ===============================
 SESSION REMAINING SLOTS / STATUS
 - Public if userId is null
 - Protected if userId exists
================================ */
export const getSessionRemainingSlots = (sessionId, userId = null) => {
 // PUBLIC (no auth)
 if (!userId) {
 return axiosInstance.get(
 `/public/sessions/${sessionId}/remaining-slots`
 );
 }

 // AUTHENTICATED
 return axiosInstance.get(
 `/client/session/${sessionId}/remaining-slots`,
 { params: { userId } }
 );
};

/* ===============================
 BOOK SESSION
================================ */
export const bookSession = (sessionId) => {


 return axiosInstance.post(
 `/client/session/${sessionId}/book`
 );
};

/* ===============================
 CANCEL SESSION
================================ */
export const cancelSession = (sessionId) => {
 return axiosInstance.post(`/client/session/${sessionId}/cancel`
 );
};

/* ===============================
 GENERATE / GET ZOOM LINK
================================ */
export const generateZoomLink = (userId, sessionId) => {
 return axiosInstance.get(`/client/session/${sessionId}/zoom-link`, {
 params: { userId },
 });
};

/* ===============================
 GET EXISTING ZOOM LINK
================================ */
export const getExistingZoomLink = (sessionId) => {
 return axiosInstance.get(
 `/client/session/${sessionId}/zoom-link/existing`
 );
};
